import React, { useState, useEffect, useRef } from 'react';
import { json, useLocation, useNavigate, useParams } from 'react-router-dom';
import api from 'api/api';
import arrowleft from 'assets/arrowleft.png';
import redmic from 'assets/redmic.png';
import copydark from 'assets/copy.svg';
import printdark from 'assets/printicon.svg';
import MenuIcon from '@mui/icons-material/Menu';
import GridViewIcon from '@mui/icons-material/GridView';
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Copyall from 'assets/bi_copy.svg';
import { Backdrop, CircularProgress, Snackbar } from '@mui/material';
import ArchiveRecordingScreen from 'pages/recording/archiveRecording';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSave, faUpRightFromSquare, faShareNodes, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import ToastModal from 'alerts/recordingscreen/toastmodal';
import DangerousIcon from '@mui/icons-material/Dangerous';
import { eventBus } from '../utils/eventbus/eventBus';
import ToastMessage from 'utils/muialerts/simplealert';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import expandicon from 'assets/expand.png'
import adveditpng from 'assets/advediting.png'
import icroundmic from'assets/ic_round-mic.svg'
import { Expand, NoteTwoTone } from '@mui/icons-material';
import MicIcon from '@mui/icons-material/Mic';
import IndividualRecording from 'pages/recording/indrecording';
import useModalStore from 'zustand/zustandstore';
import DashboardIcon from '@mui/icons-material/Dashboard';

import CloseIcon from '@mui/icons-material/Close';
import Share from 'basic/modals/share';
import ShareModal from 'basic/modals/share';
import ArcheiveStreaming from 'basic/archeivestreaming/archeiveStreaming';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import ExitModal from 'streaming/exitmodal';
import transcripticon from '../assets/transcripticon.png'
import DeleteConfirmation from 'streaming/deleteconfirmation';
import useAudioRecorder from 'streaming/audiorecorderhook';
import ReactQuill from 'react-quill';
import { formatToText } from 'utils/jsonhandlers/jsontohtml';
import './quill.css'
import { saveAudioInIndexDB } from 'offlinestreaming/offlineBlobHandler';
import TranscriptModal from 'basic/modals/transcriptmodal';
import V2header from './v2header';
import addmic from '../assets/addmic.png'
import medicationicon from '../assets/medication.png'
import labsicon from '../assets/labs.png'
import managetemplateicon from '../assets/managetemplateicon.png'
import copyblue from '../assets/copyblue.png'
import printblue from '../assets/printblue.png'
import deleteicon from '../assets/deleteicon.png'
import {  faFileAlt, faEdit, faFlask, faPills, faFile, faCopy,  } from '@fortawesome/free-solid-svg-icons';
import MockeditEditScreen from './mockeditsccreen';
import DeleteRecord from './modals/deleterecord';
import TimeLine from './tables/timeline';
import back from '../assets/backarraow.png'
import Insights from './tables/insights';
import FeauturesUnavailable from './modals/feauturesunavailable';
import TimeLineStepper from './tables/timeline';
import ImageModal from './modals/imagemodal';
import MRModal from './modals/mrmodal';
import VisitSummarymodal from './modals/visitsummarymodal';
import archeiveicon from '../assets/archeive.png'
import { convertToddmmyyy } from 'utils/date';
import TextModal from './modals/textmodal';
import axios from 'axios';
import { generateFilename } from './utils/filename';
import Encountermodal from './modals/encountermodal';
import BasicPdfRender from 'basic/basicutils/basicpdfrender';
import PdfRender from 'pages/recording/pdfrender';
import CombinedSummaryModal from './modals/combinedsummarymodal';
const V2EditScreen = ({setui,user, clicked,setstatus}) => {
  const [isRecording, setIsRecording] = useState(false);
      const {setModalValue } = useModalStore();
  const [indisRecording,setIndIsRecording]=useState(false)
    const [isbuttonloading,setIsButtonLoading]=useState(false)
  const[isdeletedaudio,setIsdelted]=useState(false)
  const [indisDeletedAudio,setIndIsDeletedAudio]=useState(false)
  const [streamfilename,setStreamfilename]=useState('')
   const [deleteconfirmationModal,setDeleteConfirmationModal]=useState(false)
  const [isExitModal,setIsexitModal]=useState(false)
  const [ismockscreen,setIsMockScreen]=useState(false)
  const[rosdata,setRosData]=useState({})
  const [rosmodal,setRosmodal]=useState(false)
  const[rosloading,setRosLoading]=useState(false)
  const [open, setOpen] = useState(false);
  const[jsonData,setJsonData]=useState([])
  const dataref=useRef({})
    const [audioSrc, setAudioSrc] = useState(null);
const [sectiondata,setSectionData]=useState({})
const [combinedsummarymodal,setCombinedsummarymodal]=useState(false)
  const[mycard,setMyCard]=useState('')
  const [ispdfshow,setIspdfShow]=useState(false)
    const [pdffile,setPdffile]=useState()
const [isTimeLineLoading,setIstimeLineLoading]=useState(false)
const [isencountermodal,setIsEncounterModal]=useState(false)
const[encounterdata,setEncounterdata]=useState([])
const[popup,setPopUp]=useState(false)
   const[myimgurl,setMyimgUrl]=useState('')
const [selectedCard,setSelectedCard]=useState('')
const[deletemodal,setDeletemodal]=useState(false);
const [isSharemodal,setIsShareModal]=useState(false)
  const [summaryjson,setSummaryJson]=useState([])
  const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [isError,setIsError]=useState(false)
  const[isLoading,setIsLoading]=useState(false)
  const mydata = useModalStore();
  const[config,setConfig]=useState({})
  const [userconfig,setUserconfig]=useState()
  const [timelinedata,setTimeLineData]=useState({})
  const [imgdata,setImgData]=useState([])
  const[audiofile,setAudiofile]=useState()
  const[toast,setToast]=useState(false)
  const [isExpanded,setIsexpanded]=useState(false)
  const [expandedRows, setExpandedRows] = useState({}); 
  const [rowSizes, setRowSizes] = useState({}); 
  const [ismrmodal,setIsMrmodal]=useState(false)
  const [isimgdata,setisimgdata]=useState({})
  const [isimgmodal,setIsimgmodal]=useState(false)
  const [ismrdata,setismrdata]=useState({})
  const [visitsummarydata,setvisitsummary]=useState({})
  const [isvisitsummarygmodal,setIsvisitsummarymodal]=useState(false)
  const [data, setData] = useState({});
  const [view,setView]=useState(2)
  const excludedKeys = ["Date", "Patient_ID", "Patient_Name", "Visit_Summary", "Appointment_Summary"];
  const [recordingField,setRecordingField]=useState('')
  const [isIndRecord,setIsIndRecord]=useState(false) 
   const [elapsedTime, setElapsedTime] = useState(0);
   const [isPaused, setIsPaused] = useState(false);
   const recorderRef = useRef(null);
   const token = sessionStorage.getItem("auth");
   const ismanualstop=useRef(false)
const ismanualrecordstart=useRef(false)
const streamname=useRef()

   const[transciptFile,setTranscriptFile]=useState('')
     const [showtranscript,setShowTranscript]=useState(false)
   const audioStreamRef = useRef(null);
   const startTimeRef = useRef(null); // Tracks the timer's start/resume time
  const timerRef = useRef(null);
  const pausedref=useRef(false)
        const [loguser,setLoguser]=useState('')
  const wsRef = useRef(null)
  const indref=useRef(null)
  const menuRef = useRef(null);
const location =useLocation()
  const recordingfieldref=useRef('')
  const[feauturesunavailable,setFeauturesunavailable]=useState(false)
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };
  
  const [fields, setFields] = useState({
    chiefcomplaint: '',
    hpi: '',
    ros: '',
    physicalexam: '',
    assessment: '',
    plan: ''
  });
  
  const [toastobject,setToastObject]=useState({
    icon:DangerousIcon,
    text1:"Something Went Wrong",
    text2:""

  })
  const percentage = 100;
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };
  const navigate = useNavigate();
  // const { id ,name} = useParams();
  const [showMenu, setShowMenu] = useState(false);

  const menuOptions = [
    { label: 'Audio/Transcript', icon: transcripticon,isallow:['BASIC','PRO',"PLUS",'BUSINESS'],ishide:false,isnotvisable:[], event:()=>{handletranscript()}},
    { label: 'Advanced Editing', icon: adveditpng ,isallow:['PRO',"PLUS"],isnotvisable:['BUSINESS'],ishide:mydata.selectedRecord?.transcriptionstatus==='APPROVED'?true:false,
     event:()=>{navigate(`/modify-template/${mydata.selectedRecord?.id}`)}},
    { label: 'Archive', icon: archeiveicon ,isallow:['PRO',"PLUS",'BASIC'],isnotvisable:['BUSINESS'],ishide:false, event:()=>{
      const timestamp = new Date().getTime();
      const profilePhotoUrl = null;
      if(mydata.usertype==='PRO'){
        navigate(`/archive/${mydata.selectedRecord.patientid}`, { state: { ts: timestamp, profile_photo: '' } });
      }else if(mydata.usertype=='PLUS'||mydata.usertype=='BASIC'){
            navigate(`/basic-archive/${mydata.selectedRecord.patientid}`, {
        state: { ts: timestamp, profile_photo: profilePhotoUrl },
      });
      } else if(mydata.usertype=='BUSINESS'){
        navigate(`/basic-archive/${mydata.selectedRecord.id}`, {
          state: { ts: timestamp, profile_photo: profilePhotoUrl }})

      }
     return
   
    }},
    // { label: 'Labs', icon: labsicon ,isallow:[]},
    // { label: 'Medications', icon: medicationicon ,isallow:[]},
    { label: 'Manage Templates',isallow:['BASIC','PRO',"PLUS"],isnotvisable:['BUSINESS'],ishide:false, icon: managetemplateicon, event:()=>{
      if(mydata.usertype==='PRO'){
        if(user?.config&&user?.config?.ehrid=='3'){
          navigate('/temp')
        }else{
                    navigate('/manage-template')
        }

      }else{
        navigate('/temp')
      }
    } },
    {label:'Print',ishide:false,isnotvisable:[],icon:printblue, isallow:['BASIC','PRO',"PLUS",'BUSINESS'],event:()=>{  handlepdf(data.audiolink,data)}},
    { label: 'Copy',isnotvisable:[], icon: copyblue ,event:()=>{handleCopyallText()} ,ishide:false,isallow:['BASIC','PRO',"PLUS","BUSINESS"]},
    { label: 'Delete',isnotvisable:['PRO'], icon: deleteicon ,event:()=>{setDeletemodal(true)},ishide:false,isallow:['BASIC',"PLUS" ,'PRO','BUSINESS']
    }
  ];
  const blocker=useRef(false)
const[copyFeedback,setCopyFeedback]=useState('')
const handleClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpen(false);
}; 
const onSaving = (blob) => {
  if (blob && blob.type.startsWith("audio/")) {   
    console.log("Valid audio blob:", blob);
    // Call the function to submit the audio blob
    if(blocker.current){
      return
    }
    submitAudioBlobManually(blob);
  } else {
    console.error("Invalid blob. Not an audio file.");
  }

};
const {  manualrecord, stopmanualRecording, pausemanualRecording , resumemanualRecording } = useAudioRecorder(onSaving);
 const handlealertClick = (message, severity) => {
  setAlertMessage(message);
  setSeverity(severity);
  setOpen(true);
};

const fetchimgdata=async()=>{
  setImgData([])
 try {
  const imgdata=await api.get(`/v1/patients/encounter-document/${dataref.current.config?.patientid}`)
  if (imgdata.status === 200 ) {
    setImgData(imgdata.data||[]);
  } else {
    setImgData([]);
  }
  
 } catch (error) {
  console.log(error)
 }finally{

 }
}

const fetchtimeline=async()=>{
  try {
    setTimeLineData({})
    setIstimeLineLoading(true)
    const response= await api.get(`/v1/patients/labs-timeline/${dataref.current.config?.patientid}`)

    if(response.status===200){
      const reversedData = Object.fromEntries(Object.entries(response?.data || {}).reverse());
setTimeLineData(reversedData);



    }else{
      setTimeLineData({})
    }
   
  } catch (error) {
    console.log(error)
  }finally{
setIstimeLineLoading(false)
  }
}

  const fetchData = async () => {
    setIsLoading(true)
    setFields({
      chiefcomplaint: '',
      hpi: '',
      ros: '',
      physicalexam: '',
      assessment: '',
      plan: ''
    })
    try {
        const user = await api.get("/auth/me");
        setLoguser(user)
         const response = await api.get(`/v1/recording/note/${mydata.selectedRecord?.id}/get`);
      if (response.status === 200) {
          const initialData =response.data[0]
        setData(initialData);
        dataref.current=initialData;
        const notesArray = Object.keys(initialData?.note_json||{})
        .filter(key => !excludedKeys.includes(key)) 
        .map((key, index) => ({
            id: index + 1,
            label: key.replace(/_/g, " "),
            key: key,
            title: key,
            value: initialData.note_json[key],
            placeholder: key,
        }));
 
        
        const order = [
          "chief_complaint",
          "physical_examination",
          "review_of_systems",
          "hpi",
          "assessment",
          "plan",
          "patient_directions",
          "allergies",
          "family_history",
          "medical_history",
          "social_history",
          "surgical_history",
        ];
        
        const sortedData = Array.isArray(notesArray)
          ? [
              ...order
                .map((key) =>
                  notesArray.find((item) => item.key?.toLowerCase() === key?.toLowerCase())
                )
                .filter(Boolean),
              ...notesArray.filter(
                (item) => !order.some((key) => key?.toLowerCase() === item.key?.toLowerCase())
              ),
            ]
          : [];
        
        
        // const sortedData = Array.isArray(notesArray)
        // ? notesArray.slice().sort((a, b) => a.key.localeCompare(b.key)) // Sort by key in alphabetical order
        // : [];
      
        // setSummaryJson(initialData?.summary_json||{})
        const transformKeysToLowercase = (obj) => {
          if (!obj || typeof obj !== 'object') return obj;
        
          return Object.keys(obj).reduce((acc, key) => {
            acc[key.toLowerCase()] = obj[key];
            return acc;
          }, {});
        };
        
        setSummaryJson(transformKeysToLowercase(initialData?.summary_json || {}));
        
setJsonData(sortedData||[])
setUserconfig(response.data[0])
        setConfig(response.data[0].config)
        setFields(initialData?.note_json)
      }
    } catch (error) {
      console.error('Error fetching data', error);
    }finally{
      setIsLoading(false)
    }
    
  };

  useEffect(() => {
    if(mydata.selectedRecord?.id){
      setData({})
        fetchData();
      
    }  
  }, [mydata]);
useEffect(()=>{
  
if(location.state?.selectedRecord){
console.log(location.state.selectedRecord,'here')
  setModalValue({selectedRecord:location.state.selectedRecord})  
}
},[location?.state])
useEffect(()=>{
  if(data?.config?.patientid&&mydata?.usertype==='PRO'){
    fetchtimeline()
    fetchimgdata()
  }

},[data?.config?.patientid])


  const submitAudioBlobManually=async(blob)=>{
    
    if(isdeletedaudio){
      setAudiofile('')
      handlealertClick('Recording has been Deleted','error')
    }else{
  
      try {
let modifiedcategory='combine'

if(indref.current){
   modifiedcategory= recordingfieldref.current
  }       
      console.log("inserting into index db ...")
    
  saveAudioInIndexDB({
    file:blob, practiceid:config.practiceid, departmentid:config.departmentid
    , patientid:config.patientid, notes:'testing data', tags:'tagsdata', 
    patientname:mydata.selectedRecord?.patient_name, templatename:config?.template_name||null, role:mydata.usertype, 
     filename: streamname.current,appointmentid:"",category:modifiedcategory,
     appointmentid:config?.appointmentid||null,rowid:mydata.selectedRecord?.id,status:"edit",streamingfilename:data.audiolink,userid:userconfig.user_id
 })
        
      } catch (error) {
        console.error('Error uploading audio:', error);
      }finally{
        setIsError(false)
        setIsexitModal(false)
      }
      
      }    
  
  }
  const submitdata = async (payload, text,fieldname) => {
    const a = fieldname;
    const b = text;
    const obj = { [a]: b };
    const transformedData = {
      "context_dict": obj 
    };
    setIsLoading(true); 
   
    try {
      const response = await api.put('/v1/recording/category/update',{
            ...transformedData,
        file_name:data.audiolink
      
      });
      fetchData()
      // Handle response here if needed
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
   
  };
  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      const response = await api.delete('/v1/recording/delete', {
        data: {
          rowid: id, // Sending the payload with rowid
        },
      });
      // setModalValue({trigger:true})
      
      setAlertMessage('Record Has Been Deleted')
      setOpen(true)
    
      setModalValue({ screen :0}) 
 setui(0)
    } catch (error) {
      console.error('Error deleting record:', error);
    } finally {
       eventBus.emit('refreshDashboard');
      setIsLoading(false);
    }
  };
  const handleDeleteRecord=()=>{
    setDeletemodal(false)    
    handleDelete(clicked.id)
  }
const handleplay=async()=>{
  try {
    const audioresponse = await api.get(`/v1/audio/${data.audiolink}`, {
      responseType: "blob", // Make sure response is treated as a Blob
    });
  
    const fileBlob =audioresponse;
    const audioURL = URL.createObjectURL(fileBlob);
        setAudioSrc(audioURL);
        if(fileBlob&&fileBlob.size==0){
          setAudioSrc('')
  
           }
  } catch (error) {
    console.log(error)
    handlealertClick('something went wrong while getting audio','error')
    setAudioSrc('')
  }
}

  const handletranscript=async()=>{
    setIsLoading(true)
 
try {
  const response = await api.get(`/v1/trascript/${data.audiolink}`);
     handleplay()
  if (response.status === 200) {
    let transcript = response.data.trim();
    if (transcript.startsWith('"') && transcript.endsWith('"')) {
      transcript = transcript.slice(1, -1);
    }
    setTranscriptFile(transcript);
    setShowTranscript(true);
  }else{
    handlealertClick(response.message,'info')
  }
  

} catch (error) {
  console.log(error)
  handlealertClick('something went wrong','error')
}finally{
setIsLoading(false)
}

  }
  const handleEditTranscript=async(text)=>{
    try {
      setIsLoading(true)
      const response=await api.put(`/v1/transcript`,{
        "audio_link": data.audiolink,
        "transcript": text
      })
      if(response.status===200){
        handlealertClick(response.message,'success')
      }else{
      handlealertClick(response.message,'info')
    
      }
    
    } catch (error) {
      console.log(error)
      handlealertClick('something went wrong','error')
    }finally{
    setIsLoading(false)
    handletranscript()
    }
    
    
      }
  const handleSignoff=async()=>{
    
    if(isbuttonloading)return
    setIsButtonLoading(true)
    try {
      const response= await api.put('/v1/document/sign-off',{"document_name":data?.audiolink})
      if(response.status===200){
       handlealertClick('Signed!');
      
        setOpen(true);
      }else if(response.status===201){
              handlealertClick(response.message)
        setOpen(true);    
      }
    } catch (error) {
      console.log(error)
      handlealertClick(('something went wrong','error'))
  
      setOpen(true);  
    }finally{
      setIsButtonLoading(false)
      fetchData()
    }
    setTimeout(() => {
    setui(0)
    }, 1000);
  }
  
  const copyToClipboard = (htmlText) => {
    // Create a temporary div to parse HTML
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlText;
    tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
    // Extract plain text without HTML tags
    const plainText = tempElement.innerText || tempElement.textContent;

    // Copy to clipboard
    navigator.clipboard.writeText(plainText)
      .then(() => {
        handlealertClick("Copied to clipboard!", "success");
      })
      .catch(err => {
        console.error("Failed to copy text: ", err);
      });
  };
  const handlepdf = async (value,card) => {

    if(card.transcriptionstatus=='Processing'){
   
      handlealertClick("Update in process. Hold on!", "info");
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return
    }

    try {
      // Trigger loading spinner
      setIsLoading(true);

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()
let  response;
if(mydata.usertype=='PRO'){
   response = await api.get(`/v1/documents/PDF/${value}?_=${uniqueParam}`, {
    responseType: "blob", // Ensure response type is 'blob' for binary data
  });
}else{
    // Fetch the PDF from the server with a unique parameter to prevent caching
     response = await api.get(`/v1/basic/documents/PDF/${value}?_=${uniqueParam}`, {
      responseType: "blob", // Ensure response type is 'blob' for binary data
    });
}
  
       const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
      setIsLoading(false);
      setIspdfShow(true)
    }
  };


  const handleFieldChange = (fieldName, value) => {
    setFields(prevFields => ({ ...prevFields, [fieldName]: value }));
  };

  const handleSaveIconClick = (fieldName) => {
   const fieldValue = fields[fieldName]; 
    const dataToSubmit = {
      [fieldName]: fieldValue,
      category: fieldName
    };
    submitdata(dataToSubmit,fieldValue,fieldName);  
    // Log the details to the console
  setPopUp(false)
  };
  

  const handleSaveButtonClick = async() => {
    if (data.transcriptionstatus === 'Processing') {
      setAlertMessage('Update in process. Hold on!');
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return;
    }

       const changedFields = {};
    for (const key in fields) {
      if (fields[key] !== data[key]) {
        changedFields[key] = fields[key];
      }
    }  
    const transformedData = {
      context_dict: changedFields // Assigning changedFields directly
    };
    setIsLoading(true); 
   
    if( Object.keys(transformedData.context_dict).length === 0){
      setIsLoading(false)
      handlealertClick('No Updated Data Found','error')
      
      return
    }
    try {

      const response = await api.put('/v1/recording/category/update',{
            ...transformedData,
        file_name:data.audiolink
      
      });

     
      fetchData()
      // Handle response here if needed
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  
  };
 

const handleCopyallText = () => {
  let textToCopy = '';

  function formatValue(key, value, indent = '') {
    if (Array.isArray(value)) {
      // Format array values as a list
      return `${key}:\n${value.map(item => `${indent}- ${formatValue('', item, indent + '  ')}`).join('\n')}`;
    } else if (typeof value === 'object' && value !== null) {
      // Format nested object properties recursively
      let formattedObject = `${key}:\n`;
      for (const subKey in value) {
        if (value.hasOwnProperty(subKey)) {
          formattedObject += `${indent}${formatValue(subKey, value[subKey], indent + '  ')}\n`;
        }
      }
      return formattedObject.trim();
    } else {
      // Strip HTML if value is a string
      const tempElement = document.createElement("div");
      tempElement.innerHTML = value;
      tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
      const formattedValue = tempElement.innerText || tempElement.textContent;
      return `${key}: ${formattedValue}`;
    }
  }
  
  for (const key in fields) {
    if (fields.hasOwnProperty(key)) {
      textToCopy += `${formatValue(key, fields[key])}\n\n`;
    }
  }
  
  console.log(textToCopy);
  


  navigator.clipboard.writeText(textToCopy)
    .then(() => {
      handlealertClick('Copied to Clipboard', 'success');
    })
    .catch(err => {
      console.error('Failed to copy text: ', err);
      handlealertClick('Something went wrong', 'error');
    });
};



 function checkImage(url) {
  const img = new Image();
  img.onload = function() {
     
      setMyimgUrl(true)
  };
  img.onerror = function() {
      console.log("Failed to load image");
      setMyimgUrl(false)
  };
  img.src = url;
}
useEffect(()=>{
  if (typeof loguser === 'object' && loguser !== null) {
checkImage(`https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`)
  }

},[mydata,loguser])
const startRecording = async (category='combine') => {
  pausedref.current = false;
  try {
    const text = crypto.randomUUID();
    setStreamfilename(text)
    streamname.current=text
    const filename = data.audiolink;
    const practiceid = config.practiceid|| "";
    const departmentid = config.departmentid || "";
    const templatename=config.template_name||null

    const tags = "Sample tags";
    const patientname = mydata.selectedRecord?.patient_name;
    const isBusinessUser = mydata.usertype=='BUSINESS';
    const patientid = config.patientid
    const notes ="testing data"
    let filenameobj={
      fileExtension:'txt',
      practiceid:practiceid,
      departmentid:departmentid,
      patientid:patientid,
      currentUser:mydata.usertype,
       rowid :mydata.selectedRecord?.id,
      filename :filename,
      category:category,
    }
    if(mydata.usertype === 'PRO' ){
      filenameobj.appointmentid =clicked.appointmentid
    }
    
            const generatedfilename=generateFilename(filenameobj)
    const ws = new WebSocket(
      `wss://api.prd.brainymed.com/bs/v1/recording/streaming?token=${token}&generated_file_name=${generatedfilename}&rowid=${mydata.selectedRecord?.id}&stream_filename=${text}&practiceid=${practiceid}&departmentid=${departmentid}&patientid=${patientid}&notes=${encodeURIComponent(
        notes
      )}&tags=${encodeURIComponent(tags)}&filename=${filename}&category=${category}&patientname=${encodeURIComponent(patientname)}&template_name=${encodeURIComponent(templatename)}${
        mydata.usertype === 'PRO' ? `&appointmentid=${clicked.appointmentid}` : ''
      }`
    );
    

    wsRef.current = ws;

    ws.onopen = () => {
      if(mydata.usertype==='PRO'){
        setstatus({status:"recording",appointmentid:mydata.selectedRecord?.appointmentid})
         }
         setModalValue({recording:true})
      console.log("WebSocket connection established.");
    };

    ws.onerror = (error) => {
      if(mydata.usertype==='PRO'){
      setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
      }
      setModalValue({recording:false})
      console.error("WebSocket error:", error);
      ismanualrecordstart.current=true
      manualrecord()

  
    };

    ws.onclose = () => {
      if(mydata.usertype==='PRO'){
      setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
      }
      if(!ismanualstop.current){
        ismanualrecordstart.current=true
        console.log('manual record initiated')
        manualrecord()
        console.log("WebSocket connection closed.");
        return
      }
      setModalValue({recording:false})
      console.log("WebSocket connection closed.");
    };

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    audioStreamRef.current = stream;

    const recorder = new RecordRTC(stream, {
      type: "audio",
      recorderType: StereoAudioRecorder,
      mimeType: "audio/webm",
      timeSlice:5000, // Send data every 5 seconds
      desiredSampRate: 48000,
      numberOfAudioChannels: 1,
      ondataavailable: async (blob) => {
     
        if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
          try {
          
            const base64Data = await blobToBase64(blob);
            ws.send(base64Data);
          } catch (error) {
            console.error("Error converting blob to base64:", error);
          }
        }
      },
    });

    recorder.startRecording();
    recorderRef.current = recorder;

    setElapsedTime(0);
    startTimer();
  
    setIsPaused(false);
  } catch (error) {
    if(mydata.usertype==='PRO'){
    setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
    }
    setModalValue({recording:false})
    console.error("Error starting recording:", error);
   
  }
};
const startTimer = () => {
  startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
  timerRef.current = setInterval(() => {
    const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
    setElapsedTime(timePassed);
  }, 1000);
};

const stopTimer = () => {
  clearInterval(timerRef.current);
  timerRef.current = null;
};

const togglePause = () => {

  if (pausedref.current) {
    // Resume the timer
    pausedref.current=false
  setIsPaused(false)
    startTimer();
    if(ismanualrecordstart){
      resumemanualRecording()
    }
  } else {
    // Pause the timer
    if(ismanualrecordstart){
      pausemanualRecording()
   }
    pausedref.current=true
   setIsPaused(true)
    stopTimer();
  }

};
const stopRecording = () => {
  ismanualstop.current=true
  ismanualrecordstart.current=false
  if (recorderRef.current) {
    recorderRef.current.stopRecording(() => {
      recorderRef.current = null;
    });
  }

  if (audioStreamRef.current) {
    audioStreamRef.current.getTracks().forEach((track) => track.stop());
    audioStreamRef.current = null;
  }

  if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
    wsRef.current.close(1000, "Recording stopped by user");
  }

  stopTimer();
  setElapsedTime(0);
 setIsRecording(false)
 setIsIndRecord(false)
 setRecordingField('')
 handlealertClick('Recording Has Been Completed','success')
 if(ismanualstop.current){

   setTimeout(() => {
    indref.current=false
    recordingfieldref.current=''
  // navigate("/app");
}, 1500);
 }

};
const onExit=()=>{
  setModalValue({recording:false})
  if(ismanualrecordstart.current){
    stopmanualRecording()
     stopRecording()
    setIsexitModal(false)

    return
  } 

  stopRecording()
setIsexitModal(false)
setui(0)
}
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      resolve(reader.result.split(",")[1]);
    };
    reader.onerror = (error) => reject(error);
  });
};
const onDelete=async()=>{
  setDeleteConfirmationModal(true)

}
const deleteStream=async()=>{
  setModalValue({recording:false})
  if(mydata.usertype==='PRO'){
    setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
     }
  try {
   setIsLoading(true)
    const response=await api.post(`/v1/recording/streaming/cancel?stream_filename=${streamfilename}`)
    if(response.status===200){ 
      stopRecording()    
      setDeleteConfirmationModal(false)
handlealertClick('Your Recording is Successfully cancelled', 'error')
    }else{
      stopRecording()    
      setDeleteConfirmationModal(false)
handlealertClick('Your Recording is Successfully cancelled', 'error')
    }
    if(      blocker.current=true){
      blocker.current=true
      stopmanualRecording()
    }

  } catch (error) {
    console.log(error)
  }finally{
   setIsLoading(false)

  }
}

const handleencounters=async(prop)=>{
  try {
    setIsLoading(true)

    const response=await api.post('/v1/patients/encounter-document/by-id',{
      "patient_id": mydata.selectedRecord?.patientid,
      "encounter_document_id": prop?.encounter_document_id

    })
    if(response.status===200){
      setEncounterdata(response?.data||[])
setIsEncounterModal(true)
    }
  } catch (error) {
    console.log(error)
  }finally{
    setIsLoading(false)
  }
  console.log(prop)

  
}


const getimgs = async (prop) => {
  console.log(prop, 'prop');
  try {
    const hasImagesOrLabs = prop?.details?.images || prop?.details?.labs;
    const hasEncounterSummary = prop?.details?.encounter_summary;

    // Case 1: Medical Record
    if (prop?.details?.title === "Medical Record" || Array.isArray(prop?.details?.images)) {
      setismrdata(prop);
      setIsMrmodal(true);
    }
    // Case 2: Combined modal (both images/labs and encounter summary)
    else if (hasImagesOrLabs && hasEncounterSummary) {
      setIsLoading(true);

      let imageResponse = null;
      let summaryResponse = null;

      // Fetch images/labs
      if (prop?.details?.images) {
        imageResponse = await api.get(`/v1/patients/imaging-summary/${data?.config?.patientid}/${prop?.date}`);
      } else {
        imageResponse = await api.get(`/v1/patients/labs-readings-summary/${data?.config?.patientid}/${prop?.date}`);
      }

      // Fetch encounter summary
      summaryResponse = await api.get(`/v1/patients/encounter-summary/${prop?.details?.encounter_summary?.encounter_id}`);

      if (imageResponse?.status === 200) setisimgdata(imageResponse?.data);
      if (summaryResponse?.status === 200) setvisitsummary(summaryResponse?.data);

      setCombinedsummarymodal(true);
    }
    // Case 3: Only images/labs
    else if (hasImagesOrLabs) {
      setIsLoading(true);
      let response = {};

      if (prop?.details?.images) {
        response = await api.get(`/v1/patients/imaging-summary/${data?.config?.patientid}/${prop?.date}`);
      } else {
        response = await api.get(`/v1/patients/labs-readings-summary/${data?.config?.patientid}/${prop?.date}`);
      }

      if (response?.status === 200) {
        setisimgdata(response?.data);
        setIsimgmodal(true);
      }
    }
    // Case 4: Only encounter summary
    else if (hasEncounterSummary) {
      setIsLoading(true);
      const response = await api.get(`/v1/patients/encounter-summary/${prop?.details?.encounter_summary?.encounter_id}`);
      if (response.status === 200) {
        setvisitsummary(response.data);
        setIsvisitsummarymodal(true);
      } else {
        setvisitsummary({});
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};



useEffect(() => {
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowMenu(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);
const ExtractRos=async()=>{
  try {
    setRosLoading(true)
    let appointment_date = data?.ts?.slice(0, 10)
    const response=await api.get(`/v1/patients/encounter-document-summary/${data?.config?.patientid}`,  {
      params: {
        appointment_date: appointment_date
      }
    })
    if(response.status === 200 && response?.data?.summary?.hasOwnProperty('ros')){
      setRosData(response?.data?.summary?.ros||'')

      setRosmodal(true)
    }else{
      handlealertClick('No data available', 'info')

    }
  } catch (error) {
    console.log(error)
  }finally{
setRosLoading(false)
  }
}
  return (<>
<div className="w-full flex  flex-col-reverse sm:flex-row max-w-full overflow-x-hidden px-4 sm:px-6">
<div className='flex relative w-full gap-4 mt-6  items-center p-4'>
  <div className='w-5 h-5 absolute left-0 top-4 cursor-pointer'onClick={() => {
  if (location?.state?.back) {
    setModalValue({ screen: 0 });
    navigate(-1);
  } else {
    setModalValue({ screen: 0 });
  }
}} >
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <g clip-path="url(#clip0_7403_35126)">
    <path d="M22 11.6875H2.68555L11.1396 20.1416L10.1729 21.1084L0.0644531 11L10.1729 0.891602L11.1396 1.8584L2.68555 10.3125H22V11.6875Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_7403_35126">
      <rect width="22" height="22" fill="white"/>
    </clipPath>
  </defs>
</svg>
  </div>

        <div>
          <div
  className="relative flex justify-center items-center w-[83px] h-[83px] rounded-full ml-4"
  style={circleStyle}
>
  <div className="flex justify-center items-center w-[70px] h-[70px] bg-[#FAFAF9] rounded-full">
  <img
         src={myimgurl&&loguser?`https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`:
         'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
         alt="profile"
         className="flex justify-center items-center w-[60px] h-[60px] bg-[#C4C4C4] rounded-full"
       />
  </div>
</div>  
        </div>
    
    <div className="text-start font-sans  font-normal">
  {data?.config?.patient_name || data?.config?.patientid ? (<>
    <div className="text-xxl flex items-center gap-4 sm:text-2xl text-gray-600">
      {mydata.usertype==='BUSINESS'?<>{mydata.selectedRecord?.name}</>:data?.config?.patient_name} {mydata.usertype==='PRO'? <div className="rounded-lg sm:rounded-full sm:w-auto  px-2 py-1 text-center text-xs font-medium bg-[#DBEAFE] text-[#0E0E0E]">
     {mydata.selectedRecord?.purpose}
      </div>:<></>}
    </div>
    <div className="text-xxl text-gray-600">
    {mydata.usertype==='BUSINESS'?<>{mydata.selectedRecord?.id}</>:data?.config?.patientid ? `${data?.config?.patientid}` : ''}
  
    </div>
    {mydata.usertype==='PRO'?<> <div className="text-xxl text-gray-600">{convertToddmmyyy(mydata.selectedRecord?.dob)||''}</div></>:<></>}
 </>) : null}
</div>

          </div>



  <div>
      <V2header

  />
  </div>



</div>
{isIndRecord||isRecording?<></>:<div className='w-full flex justify-center sm:justify-between flex-wrap  gap-4 sm:gap-0 items-center px-4 mt-4 sm:mt-8 '>
      <div className='flex items-center gap-2'>
        <SplitscreenOutlinedIcon
          onClick={() => setView(1)}
          style={{ color: view === 1 ? 'black' : 'grey', cursor: 'pointer', fontSize: '26px' }}
        />
        <MenuIcon
          onClick={() => setView(0)}
          style={{ color: view === 0 ? 'black' : 'grey', cursor: 'pointer', fontSize: '30px' }}
        />
        <DashboardOutlinedIcon
          onClick={() => setView(2)}
          style={{ color: view === 2 ? 'black' : 'grey', cursor: 'pointer', fontSize: '26px' }}
        />
      </div>
      <div className='flex gap-6 items-center'>
      {mydata.usertype==='PRO'?  <div>       <button
            onClick={()=>ExtractRos()}
            disabled={isbuttonloading}
            className={`px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap ${
              rosloading ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
            }`}
          >
            {rosloading ? 'Extracting...' : 'Extract ROS'}
          </button></div>:<></>}
        {data?.transcriptionstatus === 'Summarized'&& mydata.usertype!=='BUSINESS' ?(
          <button
            onClick={handleSignoff}
            disabled={isbuttonloading}
            className={`px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap ${
              isbuttonloading ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
            }`}
          >
            {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
          </button>
        ):<></>}
        {data?.transcriptionstatus !== 'APPROVED'?<div className='cursor-pointer' onClick={() => {
        if(mydata.isOpen){
          setAlertMessage('Recording already in progress');
          setSeverity('info'); // Change severity as needed
          setOpen(true);
        return
        }
if(mydata.isStreaming ){
  startRecording()
}
        setIsRecording(true);

        setIsdelted(false);
        handlealertClick('Recording Started');
      }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
  <path d="M5.75 0.5C6.34674 0.5 6.91903 0.737053 7.34099 1.15901C7.76295 1.58097 8 2.15326 8 2.75V7.25C8 7.84674 7.76295 8.41903 7.34099 8.84099C6.91903 9.26295 6.34674 9.5 5.75 9.5C5.15326 9.5 4.58097 9.26295 4.15901 8.84099C3.73705 8.41903 3.5 7.84674 3.5 7.25V2.75C3.5 2.15326 3.73705 1.58097 4.15901 1.15901C4.58097 0.737053 5.15326 0.5 5.75 0.5ZM11 7.25C11 9.875 9.08 12.0725 6.5 12.4475V14.75H5V12.4475C2.42 12.0725 0.5 9.875 0.5 7.25H2C2 8.24456 2.39509 9.19839 3.09835 9.90165C3.80161 10.6049 4.75544 11 5.75 11C6.24246 11 6.73009 10.903 7.18506 10.7145C7.64003 10.5261 8.05343 10.2499 8.40165 9.90165C8.74987 9.55343 9.02609 9.14003 9.21455 8.68506C9.403 8.23009 9.5 7.74246 9.5 7.25H11ZM10.25 2.75H12.5V0.5H14V2.75H16.25V4.25H14V6.5H12.5V4.25H10.25V2.75Z" fill="#2C5282"/>
</svg>
        </div>:<></>}
        <div className='cursor-pointer relative'  ref={menuRef} onClick={() => setShowMenu(!showMenu)}>
          <div className='w-4 h-4 flex items-center'>
              <FontAwesomeIcon icon={faEllipsisVertical} />
          </div>
        
          {showMenu && (
            <div className='absolute top-full right-0 w-56 bg-white shadow-lg rounded-md overflow-hidden z-50'>
  {menuOptions
    .filter(option => (!(option?.isnotvisable?.includes(mydata?.usertype))&& !option.ishide))
    .map((option, index) => (
      <div
        key={index}
        className='flex items-center gap-3 p-3 hover:bg-gray-100 cursor-pointer'
        onClick={() => {
          if (option?.isallow?.includes(mydata?.usertype)) {
            option?.event?.();
          } else {
            setFeauturesunavailable(true);
          }
        }}
      >
        <img src={option.icon} alt="" />
        <span>{option.label}</span>
      </div>
    ))}
</div>

)}

        </div>
      </div>
    </div>}
  
  
   
      <div className="w-[95%] mb-2  sm:w-full flex flex-col justify-center items-center  relative h-min-[150px] h-auto  p-2 pb-3 ">
{isIndRecord||isRecording?<>
<MockeditEditScreen
 setIsexitModal={setIsexitModal}
 stopRecording={stopRecording}
 elapsedTime={elapsedTime}
 formatTime={formatTime}
 togglePause={togglePause}
 isPaused={isPaused}
 setIsPaused={setIsPaused}
 stopTimer={stopTimer}
 pausedref={pausedref}
 audioStreamRef={audioStreamRef}
 onDelete={onDelete}

/>

</>:
<div className={`flex gap-8 ${mydata.usertype !== 'PRO' ? 'w-[80%]' : 'w-full'}`}>

{view===0?
<div className='w-full mt-[4%]  flex flex-col gap-4'>
{jsonData.map((section, idx) =>
  
  (
<>
{
  summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
<div  


key={idx} className="flex cursor-pointer flex-col sm:flex-row justify-between items-center w-full min-w-full 
 h-auto sm:min-h-20 rounded-lg shadow-md pr-0 sm:pr-4 border-l-4 border-[#A2C6FD] border-t border-b border-t-gray-400 border-b-gray-400 bg-white">
  <div className="flex items-center justify-center w-full sm:w-[20%] sm:min-w-[20%] sm:max-w-[20%] h-full bg-blue-100 p-0 rounded-md">
<h1 className="text-sm font-bold text-blue-600 break-words break-all text-center w-full">
{section.label
    ? section.label
        .toLowerCase() // Ensure all letters are lowercase first
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    : ''}</h1>
  </div>
  <div className='w-full flex justify-start'>

  <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length >70
      ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 70)}...`.replace(/\n/g, '<br />')
      : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
  }}
></div>


  </div>


  <div className='flex gap-4 cursor-pointer justify-end items-center w-full sm:min-w-[20%] sm:max-w-[20%]'>
  {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}

<div className='flex gap-4 items-center justify-center flex-row '>
{section?.label==='doctor instructions'?<ShareOutlinedIcon
  onClick={(event) => {
    event.stopPropagation(); // Prevent event from bubbling up
    setSelectedCard(section);
    setIsShareModal(true);
  }}
  sx={{
    fontSize: "18px",
    color: "#676767",
    cursor: "pointer",
    marginTop: "2rem",
  }}
/>
:<></>}
<FontAwesomeIcon 
      onClick={()=>{
        setSectionData(section)
        setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
        setPopUp(true)
      }}
      icon={faUpRightFromSquare} className="text-[#7E7E7E] mt-8 cursor-pointer" />


</div>

  </div>

</div>
:<>
{section.value?

<div  
 onClick={()=>{
     setSectionData(section)
    //  console.log(formatToText(section.value)?.replace(/\n/g, '<br />'))
 console.log(
  formatToText(section.value).substring(0, 70).replace(/\n/g, '<br />') + '...'
);
console.log(typeof section.value )
        setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
        setPopUp(true)
}}

key={idx} className="flex cursor-pointer flex-col sm:flex-row justify-between items-center w-full h-auto sm:min-h-20 rounded-lg shadow-md pr-0 sm:pr-4 border-l-4 border-[#A2C6FD] border-t border-b border-t-gray-400 border-b-gray-400 bg-white">
  <div className="flex items-center justify-center w-full sm:w-[20%] sm:min-w-[20%] sm:max-w-[20%] h-full bg-blue-100 p-0 rounded-md">
<h1 className="text-sm font-bold text-blue-600 break-words break-all text-center w-full">
{section.label
    ? section.label
        .toLowerCase() // Ensure all letters are lowercase first
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    : ''}</h1>
  </div>
  <div className='w-full flex justify-start'>

  <div 
 className="mt-2 font-sans text-[#374151] px-4 text-left max-h-[4.5rem] overflow-hidden break-words"
  dangerouslySetInnerHTML={{
    __html: formatToText(section.value)?.length > 70
      ? `${formatToText(section.value).substring(0, 70)}...`.replace(/\n/g, '<br />')
      : formatToText(section.value)?.replace(/\n/g, '<br />')
  }}
></div>


  </div>


  <div className='flex gap-4 cursor-pointer justify-end items-center w-full sm:min-w-[20%] sm:max-w-[20%]'>
  {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}

<div className='flex gap-4 items-center justify-center flex-row '>
{section?.label==='doctor instructions'?<ShareOutlinedIcon
  onClick={(event) => {
    event.stopPropagation(); // Prevent event from bubbling up
    setSelectedCard(section);
    setIsShareModal(true);
  }}
  sx={{
    fontSize: "18px",
    color: "#676767",
    cursor: "pointer",
    marginTop: "2rem",
  }}
/>
:<></>}
<FontAwesomeIcon 
      onClick={()=>{
        setSectionData(section)
        setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
        setPopUp(true)
      }}
      icon={faUpRightFromSquare} className="text-[#7E7E7E] mt-8 cursor-pointer" />


</div>

  </div>

</div>:<></>}
</>
}
</>
))
}</div>

:
(view===1?
<>
<div className="w-full mt-[4%] flex flex-col gap-4">
  {jsonData.map((section, idx) => (<>
  {
    summaryjson?.[section.placeholder.toLowerCase()]?.length > 0 ?
    <div
      key={idx}
      className="flex flex-col justify-between items-center w-auto max-w-full"
      style={{
        borderRadius: "8px",
        border: "1px solid rgba(162, 198, 253, 0.40)",
        background: "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        flex: '1 0 auto', // Ensures it grows dynamically
      }}
    >
      <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
        <h1 className="text-sm font-bold text-[#262629]">
          {section.label
            ? section.label
                .toLowerCase() // Ensure all letters are lowercase first
                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
            : ''}
        </h1>

        <div className='flex gap-4 items-center'>
        {section?.label==='doctor instructions'?<ShareOutlinedIcon
         onClick={()=>{
          setSelectedCard(section)
          setIsShareModal(true)
        }}
        sx={{fontSize:"18px",color:"#676767",cursor:"pointer"}}
        />:<></>}
        

        <FontAwesomeIcon 
           onClick={()=>{
            setSectionData(section)
            setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
            setPopUp(true)
          }}
        icon={faUpRightFromSquare} className="text-[#7E7E7E] cursor-pointer" />
        </div>
      
      </div>
      <div className="w-full flex justify-start">
       
        <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 100
      ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 100)}...`.replace(/\n/g, '<br />')
      : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
  }}
></div>

      </div>
      <div className="flex mb-4 justify-end items-center w-full px-4">
        {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}
      </div>
    </div>
:<>
    {section.value?<div
      key={idx}
      className="flex flex-col justify-between items-center w-auto max-w-full"
      style={{
        borderRadius: "8px",
        border: "1px solid rgba(162, 198, 253, 0.40)",
        background: "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        flex: '1 0 auto', // Ensures it grows dynamically
      }}
    >
      <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
        <h1 className="text-sm font-bold text-[#262629]">
          {section.label
            ? section.label
                .toLowerCase() // Ensure all letters are lowercase first
                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
            : ''}
        </h1>

        <div className='flex gap-4 items-center'>
        {section?.label==='doctor instructions'?<ShareOutlinedIcon
         onClick={()=>{
          setSelectedCard(section)
          setIsShareModal(true)
        }}
        sx={{fontSize:"18px",color:"#676767",cursor:"pointer"}}
        />:<></>}
        

        <FontAwesomeIcon 
           onClick={()=>{
            setSectionData(section)
            setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
            setPopUp(true)
          }}
        icon={faUpRightFromSquare} className="text-[#7E7E7E] cursor-pointer" />
        </div>
      
      </div>
      <div className="w-full flex justify-start">
       
        <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: formatToText(section.value)?.length > 100
      ? `${formatToText(section.value).substring(0, 100)}...`.replace(/\n/g, '<br />')
      : formatToText(section.value)?.replace(/\n/g, '<br />')
  }}
></div>

      </div>
      <div className="flex mb-4 justify-end items-center w-full px-4">
        {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}
      </div>
    </div>:<></>
  }


</>}
    </>
  ))}
</div>




</>:<>
<div className="w-full mt-[4%] grid grid-cols-1 sm:grid-cols-3 gap-4">
  {jsonData.map((section, idx) => {
    let customClasses = "";

    // Determine layout based on repeating pattern
    const positionInPattern = idx % 7; // Pattern repeats every 7 items

    if (positionInPattern === 0 || positionInPattern === 1 || positionInPattern === 2) {
      // First row: 3 equal-width boxes
      customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
    } else if (positionInPattern === 3) {
      // Second row: 1 full-width box
      customClasses = "col-span-3 min-h-[120px]";
    } else if (positionInPattern === 4) {
      // Third row: less-width box
      customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
    } else if (positionInPattern === 5) {
      // Third row: more-width box
      customClasses = "col-span-3 sm:col-span-2 min-h-[120px]";
    } else if (positionInPattern === 6) {
      // Fourth row: full-width box
      customClasses = "col-span-3 min-h-[120px]";
    }

    return (<>
    {
      summaryjson?.[section.placeholder.toLowerCase()]?.length > 0 ?
      <div
        key={idx}
        className={`relative flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
        style={{
          borderRadius: "8px",
          border: "1px solid rgba(162, 198, 253, 0.40)",
          background: "#FFF",
          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
          flex: "1 0 auto",
        }}
      >
        <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
          <h1 className="text-sm font-bold text-[#262629]">
            {section.label
              ? section.label
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : ""}
          </h1>
       
         
        

<div className='flex items-center gap-4'>
{section?.label==='doctor instructions'?<ShareOutlinedIcon
         onClick={()=>{
          setSelectedCard(section)
          setIsShareModal(true)
        }}
        sx={{fontSize:"18px",color:"#676767",cursor:"pointer"}}
        />:<></>}
   <FontAwesomeIcon
            onClick={() => {
              setSectionData(section);
              setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
              setPopUp(true);
            }}
            icon={faUpRightFromSquare}
            className="text-[#7E7E7E] cursor-pointer"
          />
</div>
        
         
        </div>
        <div className="w-full flex justify-start">
          
          <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 100
      ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 100)}...`.replace(/\n/g, '<br />')
      : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
  }}
></div>
        </div>
        <div className="flex mb-2 justify-end items-center w-full px-4">
        {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}

      </div>
      </div>
 :<>
 {section?.value?<div
        key={idx}
        className={`relative flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
        style={{
          borderRadius: "8px",
          border: "1px solid rgba(162, 198, 253, 0.40)",
          background: "#FFF",
          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
          flex: "1 0 auto",
        }}
      >
        <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
          <h1 className="text-sm font-bold text-[#262629]">
            {section.label
              ? section.label
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : ""}
          </h1>
       
         
        

<div className='flex items-center gap-4'>
{section?.label==='doctor instructions'?<ShareOutlinedIcon
         onClick={()=>{
          setSelectedCard(section)
          setIsShareModal(true)
        }}
        sx={{fontSize:"18px",color:"#676767",cursor:"pointer"}}
        />:<></>}
   <FontAwesomeIcon
            onClick={() => {
              setSectionData(section);
              setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value)}))
              setPopUp(true);
            }}
            icon={faUpRightFromSquare}
            className="text-[#7E7E7E] cursor-pointer"
          />
</div>
        
         
        </div>
        <div className="w-full flex justify-start">
         
          <div 
  className="mt-2 font-sans text-[#374151] px-4 text-left"
  dangerouslySetInnerHTML={{
    __html: formatToText(section.value)?.length > 100
      ? `${formatToText(section.value).substring(0, 100)}...`.replace(/\n/g, '<br />')
      : formatToText(section.value)?.replace(/\n/g, '<br />')
  }}
></div>
        </div>
        <div className="flex absolute bottom-2 justify-end items-center w-full px-4">
        {['review of systems', 'physical examination'].includes(section.label) ? (
    <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
        {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ?'Normal':'Abnormal'}
    </div>
) : null}

      </div>
      </div>:<></>
  }
 </> }</> );
  })}
</div>
</>
)
}

{mydata.usertype=='PRO'?<div className='mt-[4%] hidden sm:flex flex-col gap-4'>
<TimeLineStepper handleencounters={handleencounters}  getimgs={getimgs} data={timelinedata} imgdata={imgdata} isTimeLineLoading={isTimeLineLoading}/>
<Insights/>
 
</div>:<></>}
    </div>
    }




        {data?.transcriptionstatus !== 'APPROVED'?<div className="flex items-center p-4 mt-6 justify-center gap-4">
          <button 
            onClick={handleSaveButtonClick} 
            className="px-16 py-2 rounded-full bg-[#1C2A3A] font-[Tahoma] text-white text-xs"
          >
            Save
          </button>
   
        </div>:<></>}
      </div>
 


    {popup ? (
  <>
    <div
      onClick={() => setPopUp(false)}
      className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto max-h-screen flex justify-center items-center px-4"
    >
      {/* Popup Content */}
      <div
        onClick={(e) => e.stopPropagation()} // Prevent closing popup when clicking inside
        className="relative shadow-[0px_2px_13px_#00000040] p-4 gap-2 w-full max-w-[550px] sm:max-w-[60%] sm:min-h-[400px] sm:max-h-[90vh] bg-white transform translate-y-12"
        style={{
          borderRadius: "8px",
          background: "white",
          overflow: "hidden",
        }}
      >
        {/* Section Label */}
        <div className="flex justify-between w-full mb-4">
          <div className="text-sm font-medium">
            {sectiondata.label
              ? sectiondata.label
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : ""}
          </div>

          <CloseIcon
            style={{ cursor: "pointer", color: "#000" }}
            onClick={() => setPopUp(false)}
          />
        </div>

        {/* Textarea */}
        <div className="h-full overflow-hidden">
          <ReactQuill
            className="w-full text-start flex-grow custom-scrollbar p-2 font-inter"
            style={{
              borderRadius: "8px",
              border: "1px solid #A2C6FD",
              background: "#FFF",
              boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
              minHeight: "200px",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
            readOnly={data?.transcriptionstatus === "APPROVED"}
            value={fields[sectiondata.key]?.replace(/\n/g, "<br/>")}
            onChange={(value) => handleFieldChange(sectiondata.key, value)}
            placeholder={sectiondata.placeholder}
            modules={{
              toolbar: [
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ script: "sub" }, { script: "super" }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ align: [] }],
                ["blockquote", "code-block"],
                ["clean"],
              ],
            }}
            formats={[
              "font",
              "size",
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "color",
              "background",
              "script",
              "sub",
              "super",
              "list",
              "bullet",
              "indent",
              "align",
              "blockquote",
              "code-block",
            ]}
          />
        </div>

        {/* Footer Section */}
        <div className="w-full flex justify-between items-center mt-4">
          {/* Copy & Print Icons */}
          <div className="flex items-center gap-4">
            <img
              style={{ width: "18px", height: "18px", cursor: "pointer" }}
              src={copydark}
              alt="Copy"
              onClick={() => copyToClipboard(fields[sectiondata.key])}
            />
            {data?.transcriptionstatus !== "APPROVED" && (
              <img
                style={{ width: "13px", height: "13px", cursor: "pointer" }}
                src={printdark}
                alt="Print"
                onClick={() => {
                  if (data.transcriptionstatus === "Processing") {
                    setAlertMessage("Update in process. Hold on!");
                    setSeverity("info");
                    setOpen(true);
                    return;
                  }
                  handleSaveIconClick(sectiondata.key);
                }}
              />
            )}
          </div>

          {/* Mic Icon */}
          {mydata.usertype !== "BUSINESS" && data?.transcriptionstatus !== "APPROVED" && (
            <div className="flex items-center gap-2">
              <MicIcon
                fontSize="small"
                style={{
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                  color: recordingField === sectiondata ? "red" : "#000",
                }}
                onClick={() => {
                  if (recordingField || data.transcriptionstatus === "Processing" || mydata.isOpen) {
                    setAlertMessage("Recording already in progress or update in process.");
                    setSeverity("info");
                    setOpen(true);
                    return;
                  }
                  setRecordingField(sectiondata.key);
                  setIsIndRecord(true);
                  indref.current = true;
                  recordingfieldref.current = sectiondata.key;
                  if (mydata.isStreaming) {
                    startRecording(sectiondata.key);
                  }
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setPopUp(false);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  </>
) : null}


      {/* Copy feedback message */}
      <Snackbar
  open={copyFeedback}
  autoHideDuration={3000}
  // onClose={handleClose}
  message="Copied to clipboard!"
  // action={action}
/>
      {mydata.usertype=='PRO'?
        <PdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
        :<BasicPdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
      }
        {showtranscript?<TranscriptModal 
setAudioSrc={setAudioSrc}
audioSrc={audioSrc}
handlealertClick ={handlealertClick } popup={showtranscript} text={transciptFile}setmodal={setShowTranscript} handleEditTranscript={handleEditTranscript}/>:<></>}
<ToastModal toastobject={toastobject} isModalOpen={toast} setModalOpen={setToast}/>
     <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
     <CircularProgress color="inherit" />
   </Backdrop>
   <TextModal ismodal={rosmodal} setismodal={setRosmodal} heading={'Extracted ROS'} text={rosdata}/>
   <FeauturesUnavailable ismodal={feauturesunavailable} setIsmodal={setFeauturesunavailable}/>
   <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
      <ExitModal savemodal={isExitModal} setModalOpen={setIsexitModal} onExit={onExit}/>
       <DeleteRecord isModalOpen={deletemodal} setIsDeleteModal={setDeletemodal} text={clicked} handledelete={handleDeleteRecord} />
       <MRModal ismodal={ismrmodal} setIsModal={setIsMrmodal} imagingdata={ismrdata}/>
       <ImageModal ismodal={isimgmodal} setIsModal={setIsimgmodal} imagingdata={isimgdata}/>
       <CombinedSummaryModal
  ismodal={combinedsummarymodal}
  setIsModal={setCombinedsummarymodal}
  quillSummary={visitsummarydata}
  imagingdata={isimgdata}
/>
       <VisitSummarymodal ismodal={isvisitsummarygmodal} setIsModal={setIsvisitsummarymodal} imagingdata={visitsummarydata}/>
       <Encountermodal ismodal={isencountermodal}  setIsmodal={setIsEncounterModal} data={encounterdata}/>
   <ShareModal 
   setSeverity={setSeverity}
   data={data}
   setAlertMessage={setAlertMessage}
   setOpen={setOpen}
   selectedCard={selectedCard}  isOpen={isSharemodal} onClose={setIsShareModal}/>
    <DeleteConfirmation savemodal={deleteconfirmationModal} setModalOpen={setDeleteConfirmationModal} onExit={deleteStream}/>
    </>
  );
};

export default V2EditScreen;
